module.exports = __webpack_public_path__ + "static/media/vivi-header-icon.26c32da5.svg";